export default {"src":"/_next/static/media/cigna-logo.4f83c308.svg","height":34,"width":105,"blurWidth":0,"blurHeight":0};